<button class="btn btn-sm btn-light mt-1 mb-1" (click)="openModalColumns(content)"
        ngbTooltip="Columns"
        placement="left"
        container="body"
        autoClose="outside">
  <i class="fa-light fa-table-columns"></i>
</button>
<ng-template #content>
  <div class="modal-header bg-primary">
    <h4 class="modal-title text-white">
      <i class="fa-light fa-table-columns me-1"></i>Columns
    </h4>
  </div>
  <div class="modal-body" id="columns-modal" ngbAutofocus>
    <small class="d-inline-flex mb-2 px-2 py-1 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2 w-100">
      Columns can be reordered by drag & drop
    </small>
    <div class="btn-group btn-group-sm mb-2 w-100">
      <button id="show-columns"
              class="btn btn-light"
              placement="top"
              ngbTooltip="Show all columns"
              container="body"
              (click)="showColumns()">
        <i class="fa-light fa-table-columns"></i>
      </button>
      <button id="hide-columns"
              class="btn btn-light"
              placement="top"
              ngbTooltip="Hide all columns"
              container="body"
              (click)="hideColumns()">
        <i class="fa-light fa-table-layout"></i>
      </button>
      <button id="sort-asc-columns"
              class="btn btn-light"
              placement="top"
              ngbTooltip="Order asc columns"
              container="body"
              (click)="orderAscColumns()">
        <i class="fa-light fa-arrow-down-a-z"></i>
      </button>
      <button id="sort-desc-columns"
              class="btn btn-light"
              placement="top" ngbTooltip="Order desc columns"
              container="body"
              (click)="orderDescColumns()">
        <i class="fa-light fa-arrow-down-z-a"></i>
      </button>
      <button title="Reset"
              class="btn btn-light"
              placement="top"
              ngbTooltip="Reset columns"
              container="body"
              (click)="resetColumns()">
        <i class="fa-light fa-arrow-rotate-right"></i>
      </button>
    </div>
    <ul class="list-group"
        dragula="{{id}}ColumnsPicker"
        [(dragulaModel)]="columns">
      <li class="list-group-item"
          id="{{'column-item-' + column.id}}"
          *ngFor="let column of columns; index as index"
          [class.d-none]="column.frozenLeft"
          [class.first-child]="index > 1 && columns[index - 1].frozenLeft && !column.frozenLeft"
      style="cursor: move; cursor: grab;">
        <div class="form-check form-switch">
          <input class="form-check-input"
                 style="cursor: pointer"
                 type="checkbox"
                 id="{{'column-switch-' + column.id}}"
                 [checked]="column.selected"
                 (click)="toggleColumn(column)">
          <label id="{{'column-label-' + column.id}}"
                 class="form-check-label text-primary" for="{{column.id}}">{{column.name}}</label>
        </div>
        <small id="{{'column-description-' + column.id}}" class="text-muted">{{column.description}}</small>
      </li>
    </ul>
  </div>
</ng-template>
